import script from "./FormSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSearch.vue?vue&type=script&setup=true&lang=js"

import "./FormSearch.vue?vue&type=style&index=0&id=327dd8a6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327dd8a6"]])

export default __exports__